module.exports = __webpack_public_path__ + "img/icon-instagram.06b36f5b.svg";